import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';
export function Locations() {
  const locations = [{
    name: 'Howell Showroom & Main Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    phoneLink: '5175457772'
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    phoneLink: '7348876556'
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    phoneLink: '2489249899'
  }];
  return <section className="py-20 bg-glass" data-id="element-1608">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1609">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1610">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1611">
            Glass Shower Doors Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1612">
            Kosin's Glass installs custom glass shower doors and enclosures
            across Southeast Michigan, including Howell, Ann Arbor, Novi,
            Brighton, Fenton, Grand Blanc, Hartland, Fowlerville, Northville,
            Lansing, East Lansing, Webberville, Williamston and nearby
            communities.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1613">
          {locations.map((loc, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-blue-50 text-center scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1614">
              <MapPin className="w-8 h-8 text-primary mx-auto mb-4" data-id="element-1615" />
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1616">{loc.name}</h3>
              <p className="text-gray-600 mb-4" data-id="element-1617">{loc.address}</p>
              <a href={`tel:${loc.phoneLink}`} className="inline-flex items-center gap-2 text-primary font-bold hover:text-primary-hover transition-colors" data-id="element-1618">
                <Phone className="w-4 h-4" data-id="element-1619" />
                {loc.phone}
              </a>
            </div>)}
        </div>
        <div className="max-w-md mx-auto bg-white p-6 rounded-2xl shadow-sm border border-blue-50 flex items-start gap-4 anim-on-scroll" data-id="element-1620">
          <Clock className="w-6 h-6 text-primary shrink-0 mt-1" data-id="element-1621" />
          <div data-id="element-1622">
            <h4 className="font-bold text-navy mb-2" data-id="element-1623">Hours of Operation</h4>
            <ul className="text-gray-600 space-y-1 text-sm" data-id="element-1624">
              <li className="flex justify-between" data-id="element-1625">
                <span data-id="element-1626">Monday–Friday:</span> <span data-id="element-1627">8:00 a.m. to 5:00 p.m.</span>
              </li>
              <li className="flex justify-between" data-id="element-1628">
                <span data-id="element-1629">Saturday:</span> <span data-id="element-1630">9:00 a.m. to 3:00 p.m.</span>
              </li>
              <li className="flex justify-between" data-id="element-1631">
                <span data-id="element-1632">Sunday:</span> <span data-id="element-1633">Closed</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}